import React, { Fragment } from 'react';
import { FeatureFlag } from 'shared/constants/featureFlags';

import PremiumFeatureRoute from '@/components/PremiumFeatureRoute';
import { RouteItem } from '@/types/router';

import NonSecuredRoute from '../NonSecuredRoute';
import SecuredRoute from '../SecuredRoute';

export function RouteResolver({ route }: { route: RouteItem }) {
    const RouteGuard = route.secure ? SecuredRoute : NonSecuredRoute;
    const FeatureWrapper =
        route.feature === FeatureFlag.Premium ? PremiumFeatureRoute : Fragment;

    return (
        <RouteGuard>
            <FeatureWrapper>{route.component}</FeatureWrapper>
        </RouteGuard>
    );
}
